"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Language = require("./Language");

Object.keys(_Language).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Language[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Language[key];
    }
  });
});

var _Locale = require("./Locale");

Object.keys(_Locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Locale[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Locale[key];
    }
  });
});

var _TranslateFunc = require("./TranslateFunc");

Object.keys(_TranslateFunc).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TranslateFunc[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TranslateFunc[key];
    }
  });
});